export { default } from "./CustomTabBar";
